import isEmptyString from './is-empty-string';

export function valueFromInput(evt: React.ChangeEvent<HTMLInputElement>): string | null {
  const value = evt.target.value;
  return isEmptyString(value) ? null : value;
}
